import React, { useEffect, useState } from 'react';
import { Table, Tag, Button, message } from 'antd';
import { fetchEtimsInvoices, retryEtimsInvoice } from '../api';

const EtimsInvoiceList = ({ farmId, refreshKey }) => {
    const [invoices, setInvoices] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async () => {
        setLoading(true);
        try {
            setInvoices(await fetchEtimsInvoices(farmId));
        } catch (err) {
            message.error('Failed to load invoices');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, [farmId, refreshKey]);

    const handleRetry = async (record) => {
        try {
            await retryEtimsInvoice({
                farmId: record.farm_id,
                mpesaTransactionId: record.mpesa_transaction_id,
                amount: record.amount,
                description: record.item_description
            });
            message.success('Retry submitted');
            load();
        } catch (err) {
            message.error('Retry failed');
        }
    };

    const columns = [
        { title: 'Invoice #', dataIndex: 'invoice_number' },
        { title: 'Description', dataIndex: 'item_description' },
        { title: 'Amount (KES)', dataIndex: 'amount', render: (v) => Number(v).toLocaleString() },
        { title: 'CU Invoice #', dataIndex: 'control_unit_invoice_number', render: (v) => v || '—' },
        {
            title: 'Status', dataIndex: 'status',
            render: (status) => <Tag color={status === 'submitted' ? 'green' : status === 'failed' ? 'red' : 'orange'}>{status.toUpperCase()}</Tag>
        },
        {
            title: 'Actions',
            render: (_, record) => record.status === 'failed' ? <Button size="small" onClick={() => handleRetry(record)}>Retry</Button> : null
        }
    ];

    return <Table rowKey="id" columns={columns} dataSource={invoices} loading={loading} />;
};

export default EtimsInvoiceList;